import { useSyncExternalStore } from 'react';
import { getConsent, getServerConsent, subscribeToConsent } from '../analytics/consent-store';
import type { CookieConsent } from '../analytics/cookie-consent';

/**
 * The visitor's cookie decision, or null while they have not made one.
 *
 * Re-renders every reader when it changes, so accepting in the banner also updates the control on
 * the legal page and vice versa — there is one answer and two places that show it.
 */
export function useCookieConsent(): CookieConsent | null {
    return useSyncExternalStore(subscribeToConsent, getConsent, getServerConsent);
}
